webpackJsonp([4],{

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Enums Filter
 */

var files = __webpack_require__(595);

var EnumsPlugin = {
	install: function install(Vue) {
		var enums = {};
		files.keys().forEach(function (key) {
			if (key === './index.js') return;
			var name = key.replace(/(\.\/|\.js)/g, '');
			enums[name] = files(key).default;
		});

		Vue.filter('enums', function (val, key) {
			return enums[key][val];
		});

		Vue.prototype.$enums = function (key) {
			return enums[key];
		};
	}
};

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(EnumsPlugin);
}

/* harmony default export */ __webpack_exports__["default"] = (EnumsPlugin);

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Vue Filters
 */

var files = __webpack_require__(596);

var FiltersPlugin = {
	install: function install(Vue) {
		files.keys().forEach(function (key) {
			if (key === './index.js') return;
			var name = key.replace(/(\.\/|\.js)/g, '');
			Vue.filter(name, files(key).default);
		});
	}
};

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(FiltersPlugin);
}

/* harmony default export */ __webpack_exports__["default"] = (FiltersPlugin);

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_path__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_app_json__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_app_json__);



/**
 * Firebase Connections
 */

// Dependencies




// Init Firebase
__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a.firebase);

// Functions
var prepIn = function prepIn(data) {
	var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	if (timestamp) {
		if (!data.createdAt) {
			data.createdAt = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database.ServerValue.TIMESTAMP;
		} else {
			data.updatedAt = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database.ServerValue.TIMESTAMP;
		}
	}

	var res = {};
	for (var key in data) {
		if (key.indexOf('$') !== 0 && key.indexOf('.key') !== 0) {
			if (data[key] && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data[key]) === 'object') {
				res[key] = prepIn(data[key], false);
			} else {
				res[key] = data[key];
			}
		}
	}

	if (data['$priority'] || data['.priority']) {
		res['.priority'] = data['$priority'] || data['.priority'];
	}

	return res;
};

/**
 * Format firebase data for output.
 * @param  {object} data Raw firebase format data
 * @return {object}
 */
var prepOut = function prepOut(data, isArray) {
	if (isArray) {
		var res = [];
		data.forEach(function (snap) {
			res.push(_buildObject(snap));
		});
		return res;
	} else {
		return _buildObject(data);
	}
};

/**
 * Build Firebase object with relevant firebase data for better references.
 * @param  {object} snap Firebase snapshot
 * @return {object}      Formatted object
 */
var _buildObject = function _buildObject(snap) {
	var res = {};

	var val = snap.val();
	var ref = snap.ref.toString().replace(__WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a.firebase.databaseURL, '');
	var key = snap.key;
	var priority = snap.getPriority();
	var length = snap.numChildren();

	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, val, {
		'$key': key,
		'$id': key,
		'$ref': ref,
		'$priority': priority,
		'$length': length
	});
};

// Refs

var Refs = function Refs(siteId) {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Refs);

	if (siteId) {
		this.settings = __WEBPACK_IMPORTED_MODULE_3_path___default.a.join('settings', siteId);
		this.notifications = __WEBPACK_IMPORTED_MODULE_3_path___default.a.join('notifications', siteId);
		this.queue = __WEBPACK_IMPORTED_MODULE_3_path___default.a.join('queue', siteId);
	}
};

/* harmony default export */ __webpack_exports__["a"] = ({
	auth: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth,
	database: __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.database,
	refs: Refs,
	prepIn: prepIn,
	prepOut: prepOut
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Auto Export for files in directory
 */

var files = __webpack_require__(597);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return LOAD_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return LOAD_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_ITEMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ADD_CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return REMOVE_CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return UNSET_CRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGOUT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UNSET_USER; });
/* unused harmony export LOAD_SETTINGS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RESET_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return LOAD_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPDATE_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DELETE_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ADD_NOTIFICATION; });
/* unused harmony export SET_NOTIFICATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ADD_QUEUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LOAD_QUEUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_QUEUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return START_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WARN_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TIMER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CANCEL_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_WARN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UNSET_TIMER; });
/**
 * Vuex Store Type Constants
 */

var LOAD_ITEM = 'LOAD_ITEM';
var LOAD_ITEMS = 'LOAD_ITEMS';

var SET_ITEM = 'SET_ITEM';
var SET_ITEMS = 'SET_ITEMS';

var SET_LOADING = 'SET_LOADING';
var SET_ERROR = 'SET_ERROR';

var ADD_CRUMB = 'ADD_CRUMB';
var REMOVE_CRUMB = 'REMOVE_CRUMB';
var SET_CRUMB = 'SET_CRUMB';
var UNSET_CRUMB = 'UNSET_CRUMB';

var LOGIN_USER = 'LOGIN_USER';
var LOGOUT_USER = 'LOGOUT_USER';
var SET_USER = 'SET_USER';
var UNSET_USER = 'UNSET_USER';

var LOAD_SETTINGS = 'LOAD_SETTINGS';
var UPDATE_SETTINGS = 'UPDATE_SETTINGS';
var SET_SETTINGS = 'SET_SETTINGS';
var RESET_SETTINGS = 'RESET_SETTINGS';

var LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS';
var UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
var DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
var ADD_NOTIFICATION = 'ADD_NOTIFICATION';
var SET_NOTIFICATION = 'SET_NOTIFICATION';

var ADD_QUEUE = 'ADD_QUEUE';
var LOAD_QUEUE = 'LOAD_QUEUE';
var SET_QUEUE = 'SET_QUEUE';

var START_TIMER = 'START_TIMER';
var WARN_TIMER = 'WARN_TIMER';
var TIMER_STATUS = 'TIMER_STATUS';
var CANCEL_TIMER = 'CANCEL_TIMER';
var SET_TIMER = 'SET_TIMER';
var SET_WARN = 'SET_WARN';
var UNSET_TIMER = 'UNSET_TIMER';

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dialog_vue__ = __webpack_require__(589);


var DialogPlugin = {
	install: function install(Vue) {
		var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		var CONSTRUCTOR = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__Dialog_vue__["a" /* default */]);
		var CACHE = {};

		function dialog(msg) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			options.message = msg;
			var dialog = CACHE[options.id] || (CACHE[options.id] = new CONSTRUCTOR());
			if (!dialog.$el) {
				var vm = dialog.$mount();
				document.querySelector(options.parent || 'body').appendChild(vm.$el);
			}
			dialog.queue.push(options);
			return dialog;
		}

		function dialogClose() {
			var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

			var dialog = CACHE[options.id] || (CACHE[options.id] = new CONSTRUCTOR());
			dialog.queue.shift();
		}

		Vue.dialog = Vue.prototype.$dialog = dialog;
		Vue.dialogClose = Vue.prototype.$dialogClose = dialogClose;
	}
};

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(DialogPlugin);
}

/* harmony default export */ __webpack_exports__["a"] = (DialogPlugin);

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_app_json__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_app_json__);
/**
 * Vue Router
 */








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: 'history',
	routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */]
});

router.beforeEach(function (to, from, next) {
	__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_4__store_types__["e" /* START_TIMER */], __WEBPACK_IMPORTED_MODULE_5__config_app_json___default.a.app.sessionDuration);
	next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14534e8d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(590);
function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var normalizeComponent = __webpack_require__(132)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14534e8d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed__);
//
//
//
//
//
//


// Plugins



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	data: function data() {
		return {
			user: {
				AccountId: '',
				EventId: '',
				Salutation: '',
				Firstname: '',
				Lastname: '',
				Title: '',
				Company: '',
				Division: '',
				Address1: '',
				Address2: '',
				City: '',
				State: '',
				Zip: '',
				Country: '',
				TelCountryCode: '',
				Phone1: '',
				Phone2: '',
				Fax: '',
				Email: '',
				URL: ''
			}
		};
	},
	mounted: function mounted() {
		if (this.$route.query) {}
	},

	watch: {
		'$route': function $route(to, from) {
			if (to.query && to.query.AccountId) {
				if (to.query.AccountId !== from.query.AccountId) {}
			}
		}
	}
});

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var suppressWarn = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].version.indexOf('1.') === 0 ? { 'transition': { template: '<div><slot></slot></div>' } } : null;

var DEFAULTS = {
	id: 'dialog',
	className: '',
	parent: 'body',
	transition: 'dialog',
	title: 'Alert',
	message: 'Look here',
	cancelText: 'close',
	confirmText: 'Confirm'
};

/* harmony default export */ __webpack_exports__["a"] = ({
	name: '',
	data: function data() {
		return {
			queue: [],
			option: {},
			showing: false
		};
	},

	components: suppressWarn,
	computed: {
		merged: function merged() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, DEFAULTS, this.option);
		}
	},
	methods: {
		close: function close() {
			this.queue.shift();
		},
		confirm: function confirm() {
			if (this.merged.confirm) {
				this.merged.confirm();
				this.queue.shift();
			}
		}
	},
	watch: {
		queue: function queue() {
			var pending = this.queue.length;
			if (!pending) {
				this.showing = false;
				return;
			}
			this.showing = true;
			this.option = this.queue[0];
		}
	}
});

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_app_json__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_app_json__);





/**
 * API Interface
 *
 * @requires Vue
 * @requires Axios
 */

// Dependencies



// Config


// Helpers
var isObject = function isObject(a) {
	return Object.prototype.toString.call(a) === '[object Object]' && a.constructor.name === 'Object';
};

var settings = JSON.parse(localStorage.getItem('settings') || '{"devMode":"false"}');
var doCache = !settings.devMode;

// API
var api = {
	_buildObject: function _buildObject(obj) {
		var key = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(obj)[0];
		obj = obj[key];
		var where = '';
		var fields = '';

		if (obj.where) {
			where += '(';
			var keys = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(obj.where);
			var wheres = [];
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(keys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var _key = _step.value;

					var val = obj.where[_key];
					wheres.push(_key + ':"' + val + '"');
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			where += wheres.join(',');
			where += ')';
		}

		if (obj.fields) {
			var fields_ = [];
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(obj.fields), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var field = _step2.value;

					if (isObject(field) || (typeof field === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(field)) === 'object') {
						fields_.push(this._buildObject(field));
					} else {
						fields_.push(field);
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			fields = fields_.join(' ');
		}

		var qs = key + ' ' + where + ' { ' + fields + ' }';
		return qs;
	},
	request: function request(params) {
		var query = this._buildObject(params);
		var qs = 'query {' + query + '}';

		var key = __WEBPACK_IMPORTED_MODULE_6_crypto___default.a.createHash('sha256').update(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(query)).digest('base64');

		var cached = sessionStorage.getItem(key);
		if (!cached || !doCache) {
			return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				__WEBPACK_IMPORTED_MODULE_5_axios___default()({
					method: 'post',
					url: __WEBPACK_IMPORTED_MODULE_7__config_app_json___default.a.app.apiUrl,
					data: {
						query: qs
					},
					headers: {
						'Content-Type': 'application/json',
						Authorization: 'Bearer ' + __WEBPACK_IMPORTED_MODULE_7__config_app_json___default.a.app.apiKey
					}
				}).then(function (res) {
					if (res.data.data) {
						resolve(res.data.data);
						sessionStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res.data.data));
					} else {
						reject(new Error('No data found'));
					}
				}).catch(function (err) {
					reject(err);
				});
			});
		}
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(JSON.parse(cached));
	}
};

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (['New', 'Active', 'Read']);

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["default"] = (function (input) {
	var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/DD/YYYY';

	if (input) {
		return __WEBPACK_IMPORTED_MODULE_0_moment___default()(input).format(format);
	}
});

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["default"] = (function (input) {
	var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	return __WEBPACK_IMPORTED_MODULE_0_moment___default()(input).fromNow(suffix);
});

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Routing
 */

// Views
var Intro = function Intro(r) {
	return __webpack_require__.e/* require.ensure */(2).then((function () {
		return r(__webpack_require__(607));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Main = function Main(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(608));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Admin = function Admin(r) {
	return __webpack_require__.e/* require.ensure */(1).then((function () {
		return r(__webpack_require__(606));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// Partials
var Notifications = function Notifications(r) {
	return __webpack_require__.e/* require.ensure */(1).then((function () {
		return r(__webpack_require__(612));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Dynamic = function Dynamic(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(609));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DynamicItem = function DynamicItem(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(610));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DynamicModal = function DynamicModal(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(611));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Shows = function Shows(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(613));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// Components
var Nav = function Nav(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(604));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AdminNav = function AdminNav(r) {
	return __webpack_require__.e/* require.ensure */(1).then((function () {
		return r(__webpack_require__(603));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Show = function Show(r) {
	return __webpack_require__.e/* require.ensure */(0).then((function () {
		return r(__webpack_require__(605));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// Routes
var routes = [{
	path: '/',
	component: Intro,
	meta: {
		requiresAuth: false,
		title: 'Intro'
	},
	children: [{
		path: '',
		name: 'shows',
		component: Shows
	}, {
		path: ':show?',
		name: 'show',
		component: Show
	}, {
		path: ':show/admin',
		meta: {
			requiresAuth: false
		},
		component: Admin,
		children: [{
			path: '',
			components: {
				nav: AdminNav,
				content: Notifications
			}
		}]
	}, {
		path: ':show/:type',
		component: Main,
		children: [{
			path: '',
			name: 'content',
			components: {
				nav: Nav,
				content: Dynamic
			}
		}, {
			path: ':id',
			name: 'item',
			components: {
				nav: Nav,
				content: DynamicItem
			},
			children: [{
				path: ':modalType/:modalId',
				name: 'modal',
				components: {
					modal: DynamicModal
				},
				meta: {
					showModal: true
				}
			}]
		}]
	}]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_store_types__ = __webpack_require__(26);



var _actions, _mutations;

/**
 * Breadcrumbs Store Module
 */

// Dependencies


// Types


var state = {
	crumbs: {}
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__lib_store_types__["B" /* ADD_CRUMB */], function (_ref, crumb) {
	var commit = _ref.commit;

	commit(__WEBPACK_IMPORTED_MODULE_3__lib_store_types__["C" /* SET_CRUMB */], crumb);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__lib_store_types__["D" /* REMOVE_CRUMB */], function (_ref2, crumb) {
	var commit = _ref2.commit;

	commit(__WEBPACK_IMPORTED_MODULE_3__lib_store_types__["E" /* UNSET_CRUMB */], crumb);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__lib_store_types__["C" /* SET_CRUMB */], function (state, crumb) {
	var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(crumb)[0];
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.crumbs, key, crumb[key]);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__lib_store_types__["E" /* UNSET_CRUMB */], function (state, key) {
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.crumbs, key, null);
}), _mutations);

var getters = {
	crumbs: function crumbs(state) {
		return state.crumbs;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_path__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuexfire__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_fb__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_app_json__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_store_types__ = __webpack_require__(26);



var _actions;

/**
 * Notification Store Module
 */







// Types


// Constants
var refs = new __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].refs(__WEBPACK_IMPORTED_MODULE_6__config_app_json__["app"].showId);

// Store
var state = {
	notifications: [],
	notification: {}
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__lib_store_types__["x" /* LOAD_NOTIFICATIONS */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuexfire__["firebaseAction"])(function (_ref, key) {
	var commit = _ref.commit,
	    bindFirebaseRef = _ref.bindFirebaseRef;

	var notificationsPath = refs.notifications;
	var notificationsRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(notificationsPath);
	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		bindFirebaseRef('notifications', notificationsRef, { readyCallback: function readyCallback() {
				resolve();
			} });
	});
})), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__lib_store_types__["y" /* ADD_NOTIFICATION */], function (_ref2, data) {
	var commit = _ref2.commit;

	var notificationsPath = __WEBPACK_IMPORTED_MODULE_2_path___default.a.join(refs.notifications);
	var notificationsRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(notificationsPath);
	var newRef = notificationsRef.push();
	var newKey = newRef.key;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		newRef.set(__WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].prepIn(data), function (res) {
			resolve(newKey);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__lib_store_types__["z" /* DELETE_NOTIFICATION */], function (_ref3, key) {
	var commit = _ref3.commit;

	var notificationPath = __WEBPACK_IMPORTED_MODULE_2_path___default.a.join(refs.notifications, key);
	var notificationRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(notificationPath);

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		notificationRef.remove(function (res) {
			resolve(key);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__lib_store_types__["A" /* UPDATE_NOTIFICATION */], function (_ref4, notification) {
	var commit = _ref4.commit;

	var key = notification.$key;
	var data = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].prepIn(notification);

	var notificationPath = __WEBPACK_IMPORTED_MODULE_2_path___default.a.join(refs.notifications, key);
	var notificationRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(notificationPath);

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		notificationRef.update(data, function (res) {
			resolve(key);
		});
	});
}), _actions);

var mutations = {};

var getters = {
	notifications: function notifications(state) {
		return state.notifications;
	},
	notification: function notification(state) {
		return state.notification;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_api__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_store_types__ = __webpack_require__(26);



var _actions, _mutations;

/**
 * Objects Store Module
 *
 * Load GraphQL Objects Data
 */

// Dependencies



// Types


// State
var state = {
	items: {},
	item: {},
	loading: 0,
	errors: {}

	// Actions
};var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__lib_store_types__["r" /* LOAD_ITEMS */], function (_ref, params) {
	var commit = _ref.commit;

	var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params)[0];
	var error = {};
	error[key] = null;

	commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["s" /* SET_LOADING */], true);
	commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["t" /* SET_ERROR */], error);
	commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["u" /* SET_ITEMS */], error);

	return __WEBPACK_IMPORTED_MODULE_3__lib_api__["a" /* default */].request(params).then(function (res) {
		commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["u" /* SET_ITEMS */], res);
	}).catch(function (err) {
		console.log(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["r" /* LOAD_ITEMS */] + '.fail', err);
		error[key] = err;
		commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["t" /* SET_ERROR */], error);
	}).then(function () {
		commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["s" /* SET_LOADING */], false);
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__lib_store_types__["v" /* LOAD_ITEM */], function (_ref2, params) {
	var commit = _ref2.commit;

	var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params)[0];
	var error = {};
	error[key] = null;
	commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["s" /* SET_LOADING */], true);
	commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["t" /* SET_ERROR */], error);
	commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["w" /* SET_ITEM */], error);

	return __WEBPACK_IMPORTED_MODULE_3__lib_api__["a" /* default */].request(params).then(function (res) {
		commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["w" /* SET_ITEM */], res);
	}).catch(function (err) {
		error[key] = err;
		console.log(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["v" /* LOAD_ITEM */] + '.fail', err);
		commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["t" /* SET_ERROR */], err);
	}).then(function () {
		commit(__WEBPACK_IMPORTED_MODULE_4__lib_store_types__["s" /* SET_LOADING */], false);
	});
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__lib_store_types__["u" /* SET_ITEMS */], function (state, items) {
	var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(items)[0];
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.items, key, items[key]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__lib_store_types__["w" /* SET_ITEM */], function (state, item) {
	var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item)[0];
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.item, key, item[key]);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__lib_store_types__["s" /* SET_LOADING */], function (state, loading) {
	if (loading) {
		state.loading++;
	} else {
		state.loading--;
	}
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'loading', state.loading);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__lib_store_types__["t" /* SET_ERROR */], function (state, error) {
	var key = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(error)[0];
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.errors, key, error[key]);
}), _mutations);

var getters = {
	items: function items(state) {
		return state.items;
	},
	item: function item(state) {
		return state.item;
	},
	loading: function loading(state) {
		return !!state.loading;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_path__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuexfire__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuexfire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_fb__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_app_json__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_app_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_store_types__ = __webpack_require__(26);



var _actions;

/**
 * Queue Store Module
 */







// Types


// Constants
var refs = new __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].refs(__WEBPACK_IMPORTED_MODULE_6__config_app_json__["app"].showId);

// State
var state = {
	queue: []
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__lib_store_types__["o" /* ADD_QUEUE */], function (_ref, data) {
	var commit = _ref.commit;

	var queuePath = __WEBPACK_IMPORTED_MODULE_2_path___default.a.join(refs.queue);
	var queueRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(queuePath);
	var newRef = queueRef.push();
	var newKey = newRef.key;

	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		newRef.set(__WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].prepIn(data), function (res) {
			resolve(newKey);
		});
	});
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_7__lib_store_types__["p" /* LOAD_QUEUE */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuexfire__["firebaseAction"])(function (_ref2, key) {
	var commit = _ref2.commit,
	    bindFirebaseRef = _ref2.bindFirebaseRef;

	var queuePath = __WEBPACK_IMPORTED_MODULE_2_path___default.a.join(refs.queue);
	var queueRef = __WEBPACK_IMPORTED_MODULE_5__lib_fb__["a" /* default */].database().ref(queuePath);
	return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
		bindFirebaseRef('queue', queueRef, { readyCallback: function readyCallback() {
				resolve();
			} });
	});
})), _actions);

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_7__lib_store_types__["q" /* SET_QUEUE */], function (state, data) {
	var res = [];
});

var getters = {
	queue: function queue(state) {
		return state.queue;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_store_types__ = __webpack_require__(26);



var _actions;

/**
 * Settings Store Module
 *
 * Load Tablet Settings
 */

// Dependencies


// Types


// Constants
var defaults = {
	tabletId: null,
	isMaster: false
};
var storageKey = 'settings';

// State
var state = {
	settings: JSON.parse(localStorage.getItem(storageKey)) || defaults
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__lib_store_types__["l" /* UPDATE_SETTINGS */], function (_ref, data) {
	var commit = _ref.commit;

	commit(__WEBPACK_IMPORTED_MODULE_3__lib_store_types__["m" /* SET_SETTINGS */], data);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__lib_store_types__["n" /* RESET_SETTINGS */], function (_ref2) {
	var commit = _ref2.commit;

	commit(__WEBPACK_IMPORTED_MODULE_3__lib_store_types__["m" /* SET_SETTINGS */], defaults);
}), _actions);

var mutations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__lib_store_types__["m" /* SET_SETTINGS */], function (state, data) {
	localStorage.setItem(storageKey, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
	__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'settings', data);
});

var getters = {
	settings: function settings(state) {
		return state.settings;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_store_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_json__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_app_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_app_json__);


var _actions, _mutations;

/**
 * Timer Store Module
 */

// Types



// State
var state = {
	timerStatus: 0,
	timerWarning: null,
	timerLogout: null
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["e" /* START_TIMER */], function (_ref, dur) {
	var commit = _ref.commit;

	commit(__WEBPACK_IMPORTED_MODULE_1__lib_store_types__["f" /* SET_TIMER */], dur);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["g" /* WARN_TIMER */], function (_ref2, dur) {
	var commit = _ref2.commit;

	commit(__WEBPACK_IMPORTED_MODULE_1__lib_store_types__["h" /* SET_WARN */], dur);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["i" /* CANCEL_TIMER */], function (_ref3) {
	var commit = _ref3.commit;

	commit(__WEBPACK_IMPORTED_MODULE_1__lib_store_types__["j" /* UNSET_TIMER */]);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["f" /* SET_TIMER */], function (state, dur) {
	state.timerStatus = 0;
	state.timerLogout = clearTimeout(state.timerLogout);
	state.timerWarning = clearTimeout(state.timerWarning);

	state.timerWarning = setTimeout(function () {
		state.timerStatus = 1;
	}, dur || __WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a.app.sessionDuration);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["h" /* SET_WARN */], function (state, dur) {
	state.timerStatus = 1;
	state.timerLogout = clearTimeout(state.timerLogout);
	state.timerLogout = setTimeout(function () {
		state.timerStatus = 2;
	}, dur || __WEBPACK_IMPORTED_MODULE_2__config_app_json___default.a.app.resumeDuration);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["k" /* TIMER_STATUS */], function (state, status) {
	state.timerStatus = status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["j" /* UNSET_TIMER */], function (state) {
	state.timerWarning = clearTimeout(state.timerWarning);
	state.timerLogout = clearTimeout(state.timerLogout);
}), _mutations);

var getters = {
	timerStatus: function timerStatus(state) {
		return state.timerStatus;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_store_types__ = __webpack_require__(26);


var _DEFAULT_USER, _actions, _mutations;

/**
 * User Store Module
 */

// Types


var DEFAULT_USER = (_DEFAULT_USER = {
	AccountId: "1401",
	EventId: "2650",
	Salutation: "Mr",
	Firstname: 'Sean',
	Middlename: "P",
	Lastname: 'Maloney',
	Email: 'smaloney@getsynchronicity.com',
	Phone1: '867-5309',
	Title: 'Area Manager',
	Company: 'GetSynchronicity',
	Division: '',
	Address1: '',
	Address2: '',
	City: '',
	State: '',
	Zip: '',
	Country: '',
	TelCountryCode: ''
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DEFAULT_USER, "Phone1", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DEFAULT_USER, "URL", ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DEFAULT_USER, "Friendly", 'Surface01'), _DEFAULT_USER);

// State
var state = {
	user: DEFAULT_USER
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["a" /* LOGIN_USER */], function (_ref, params) {
	var commit = _ref.commit;

	commit(__WEBPACK_IMPORTED_MODULE_1__lib_store_types__["b" /* SET_USER */], params);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["c" /* LOGOUT_USER */], function (_ref2) {
	var commit = _ref2.commit;

	commit(__WEBPACK_IMPORTED_MODULE_1__lib_store_types__["d" /* UNSET_USER */]);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["b" /* SET_USER */], function (state, data) {
	state.user = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__lib_store_types__["d" /* UNSET_USER */], function (state) {
	window.close();
	state.user = DEFAULT_USER;
}), _mutations);

var getters = {
	user: function user(state) {
		return state.user;
	}
};

/* harmony default export */ __webpack_exports__["default"] = ({
	state: state,
	actions: actions,
	mutations: mutations,
	getters: getters
});

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_router__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_store__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_filters__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_enums__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_dialog__ = __webpack_require__(348);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





// Plugins

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__lib_filters__["default"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__lib_enums__["default"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__lib_dialog__["a" /* default */]);

// Config
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  },
  router: __WEBPACK_IMPORTED_MODULE_2__lib_router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__lib_store__["a" /* default */]
});

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = {"app":{"showId":"jha-one","apiUrl":"https://us-central1-trunk-cms.cloudfunctions.net/api/-KxPXKESWH67qMrUhbHF","apiKey":"eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbGciOiJSUzI1NiIsImlzcyI6IiIsInN1YiI6IiIsImF1ZCI6Imh0dHBzOi8vaWRlbnRpdHl0b29sa2l0Lmdvb2dsZWFwaXMuY29tL2dvb2dsZS5pZGVudGl0eS5pZGVudGl0eXRvb2xraXQudjEuSWRlbnRpdHlUb29sa2l0IiwiaWF0IjoxNTA5MDUyNDcwLjUzNCwiZXhwIjoxNTQwNTg4NDcwLjUzNCwidWlkIjoiT1BRVXZnbEo4M1dkcjZrazRqd2xtNXRXSnkxMiIsImNsYWltcyI6eyJzaXRlSWQiOiItS3hQWEtFU1dINjdxTXJVaGJIRiIsInVpZCI6Ik9QUVV2Z2xKODNXZHI2a2s0andsbTV0V0p5MTIiLCJsZXZlbCI6MH19.QdEZIDB6V6ZjBF3kUmDFh5zHN-GchbtDIjqFvu6qvRPy9o5cYXHfks_abG8WHltmd8O8j9RqQK27tAbWPGZgM672wkW2J9kSDSeikNjG44bMJNNL6DaZbHgezjzJvo0MbcFxWeIy0oGFu4dyXrbRxgPQTNyOWaYcZYIgev0gr3mY5Ldf3YPr6S_xToK6XO95lu5EpWdASBqYfkh4V65g4WQEgTBUw1gmy5QlrvFxSJfRVlRZ9KmDIAdQP27psskBQMMUMIAs4K44mWIjT6xYKeV2pvDJYjZ0CNVgvf91YKx9hSBGH_CyRWjjOHLBxddX8uaVeZr-ZEVU4Sv9FW9ayA","sessionDuration":60000,"resumeDuration":10000},"firebase":{"apiKey":"AIzaSyB-UEwDJ_JmlZtjnCwLt5voi7oxgPbC4bg","authDomain":"jha-library.firebaseapp.com","databaseURL":"https://jha-library.firebaseio.com","projectId":"jha-library","storageBucket":"jha-library.appspot.com"}}

/***/ }),

/***/ 484:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 485:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.0.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.0.0","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.0.0","saveSpec":null,"fetchSpec":"^6.0.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_shasum":"cac9af8762c85836187003c8dfe193e5e2eae5df","_spec":"elliptic@^6.0.0","_where":"/Users/tmaloney/Documents/sites/motionkick/jha/jha.webapp/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 216,
	"./af.js": 216,
	"./ar": 223,
	"./ar-dz": 217,
	"./ar-dz.js": 217,
	"./ar-kw": 218,
	"./ar-kw.js": 218,
	"./ar-ly": 219,
	"./ar-ly.js": 219,
	"./ar-ma": 220,
	"./ar-ma.js": 220,
	"./ar-sa": 221,
	"./ar-sa.js": 221,
	"./ar-tn": 222,
	"./ar-tn.js": 222,
	"./ar.js": 223,
	"./az": 224,
	"./az.js": 224,
	"./be": 225,
	"./be.js": 225,
	"./bg": 226,
	"./bg.js": 226,
	"./bm": 227,
	"./bm.js": 227,
	"./bn": 228,
	"./bn.js": 228,
	"./bo": 229,
	"./bo.js": 229,
	"./br": 230,
	"./br.js": 230,
	"./bs": 231,
	"./bs.js": 231,
	"./ca": 232,
	"./ca.js": 232,
	"./cs": 233,
	"./cs.js": 233,
	"./cv": 234,
	"./cv.js": 234,
	"./cy": 235,
	"./cy.js": 235,
	"./da": 236,
	"./da.js": 236,
	"./de": 239,
	"./de-at": 237,
	"./de-at.js": 237,
	"./de-ch": 238,
	"./de-ch.js": 238,
	"./de.js": 239,
	"./dv": 240,
	"./dv.js": 240,
	"./el": 241,
	"./el.js": 241,
	"./en-au": 242,
	"./en-au.js": 242,
	"./en-ca": 243,
	"./en-ca.js": 243,
	"./en-gb": 244,
	"./en-gb.js": 244,
	"./en-ie": 245,
	"./en-ie.js": 245,
	"./en-nz": 246,
	"./en-nz.js": 246,
	"./eo": 247,
	"./eo.js": 247,
	"./es": 250,
	"./es-do": 248,
	"./es-do.js": 248,
	"./es-us": 249,
	"./es-us.js": 249,
	"./es.js": 250,
	"./et": 251,
	"./et.js": 251,
	"./eu": 252,
	"./eu.js": 252,
	"./fa": 253,
	"./fa.js": 253,
	"./fi": 254,
	"./fi.js": 254,
	"./fo": 255,
	"./fo.js": 255,
	"./fr": 258,
	"./fr-ca": 256,
	"./fr-ca.js": 256,
	"./fr-ch": 257,
	"./fr-ch.js": 257,
	"./fr.js": 258,
	"./fy": 259,
	"./fy.js": 259,
	"./gd": 260,
	"./gd.js": 260,
	"./gl": 261,
	"./gl.js": 261,
	"./gom-latn": 262,
	"./gom-latn.js": 262,
	"./gu": 263,
	"./gu.js": 263,
	"./he": 264,
	"./he.js": 264,
	"./hi": 265,
	"./hi.js": 265,
	"./hr": 266,
	"./hr.js": 266,
	"./hu": 267,
	"./hu.js": 267,
	"./hy-am": 268,
	"./hy-am.js": 268,
	"./id": 269,
	"./id.js": 269,
	"./is": 270,
	"./is.js": 270,
	"./it": 271,
	"./it.js": 271,
	"./ja": 272,
	"./ja.js": 272,
	"./jv": 273,
	"./jv.js": 273,
	"./ka": 274,
	"./ka.js": 274,
	"./kk": 275,
	"./kk.js": 275,
	"./km": 276,
	"./km.js": 276,
	"./kn": 277,
	"./kn.js": 277,
	"./ko": 278,
	"./ko.js": 278,
	"./ky": 279,
	"./ky.js": 279,
	"./lb": 280,
	"./lb.js": 280,
	"./lo": 281,
	"./lo.js": 281,
	"./lt": 282,
	"./lt.js": 282,
	"./lv": 283,
	"./lv.js": 283,
	"./me": 284,
	"./me.js": 284,
	"./mi": 285,
	"./mi.js": 285,
	"./mk": 286,
	"./mk.js": 286,
	"./ml": 287,
	"./ml.js": 287,
	"./mr": 288,
	"./mr.js": 288,
	"./ms": 290,
	"./ms-my": 289,
	"./ms-my.js": 289,
	"./ms.js": 290,
	"./my": 291,
	"./my.js": 291,
	"./nb": 292,
	"./nb.js": 292,
	"./ne": 293,
	"./ne.js": 293,
	"./nl": 295,
	"./nl-be": 294,
	"./nl-be.js": 294,
	"./nl.js": 295,
	"./nn": 296,
	"./nn.js": 296,
	"./pa-in": 297,
	"./pa-in.js": 297,
	"./pl": 298,
	"./pl.js": 298,
	"./pt": 300,
	"./pt-br": 299,
	"./pt-br.js": 299,
	"./pt.js": 300,
	"./ro": 301,
	"./ro.js": 301,
	"./ru": 302,
	"./ru.js": 302,
	"./sd": 303,
	"./sd.js": 303,
	"./se": 304,
	"./se.js": 304,
	"./si": 305,
	"./si.js": 305,
	"./sk": 306,
	"./sk.js": 306,
	"./sl": 307,
	"./sl.js": 307,
	"./sq": 308,
	"./sq.js": 308,
	"./sr": 310,
	"./sr-cyrl": 309,
	"./sr-cyrl.js": 309,
	"./sr.js": 310,
	"./ss": 311,
	"./ss.js": 311,
	"./sv": 312,
	"./sv.js": 312,
	"./sw": 313,
	"./sw.js": 313,
	"./ta": 314,
	"./ta.js": 314,
	"./te": 315,
	"./te.js": 315,
	"./tet": 316,
	"./tet.js": 316,
	"./th": 317,
	"./th.js": 317,
	"./tl-ph": 318,
	"./tl-ph.js": 318,
	"./tlh": 319,
	"./tlh.js": 319,
	"./tr": 320,
	"./tr.js": 320,
	"./tzl": 321,
	"./tzl.js": 321,
	"./tzm": 323,
	"./tzm-latn": 322,
	"./tzm-latn.js": 322,
	"./tzm.js": 323,
	"./uk": 324,
	"./uk.js": 324,
	"./ur": 325,
	"./ur.js": 325,
	"./uz": 327,
	"./uz-latn": 326,
	"./uz-latn.js": 326,
	"./uz.js": 327,
	"./vi": 328,
	"./vi.js": 328,
	"./x-pseudo": 329,
	"./x-pseudo.js": 329,
	"./yo": 330,
	"./yo.js": 330,
	"./zh-cn": 331,
	"./zh-cn.js": 331,
	"./zh-hk": 332,
	"./zh-hk.js": 332,
	"./zh-tw": 333,
	"./zh-tw.js": 333
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 568;

/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dialog_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b514de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__ = __webpack_require__(591);
function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var normalizeComponent = __webpack_require__(132)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64b514de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b514de_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dialog"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showing),expression:"showing"}],staticClass:"dialog-mask",on:{"click":function($event){_vm.close()}}},[_c('div',{staticClass:"dialog-wrapper"},[_c('div',{staticClass:"dialog-container",on:{"click":function($event){$event.stopPropagation();}}},[_c('header',{staticClass:"dialog-header"},[_c('h5',[_vm._v(_vm._s(_vm.merged.title))])]),_vm._v(" "),_c('article',{staticClass:"dialog-content"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.merged.message)}})]),_vm._v(" "),_c('footer',{staticClass:"dialog-footer"},[_c('a',{staticClass:"mdc-button mdc-button--dense",on:{"click":function($event){_vm.close()}}},[_vm._v(_vm._s(_vm.merged.cancelText))]),_vm._v(" "),(_vm.merged.confirm)?_c('a',{staticClass:"mdc-button mdc-button--primary",on:{"click":function($event){_vm.confirm()}}},[_vm._v(_vm._s(_vm.merged.confirmText))]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./index.js": 130,
	"./notificationStatus.js": 384
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 595;

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./dateFormat.js": 385,
	"./index.js": 131,
	"./timeAgo.js": 386
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 596;

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Crumb.js": 388,
	"./Notification.js": 389,
	"./Object.js": 390,
	"./Queue.js": 391,
	"./Settings.js": 392,
	"./Timer.js": 393,
	"./User.js": 394,
	"./index.js": 145
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 597;

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuexfire__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuexfire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuexfire__);

/**
 * Vuex Store
 *
 * @requires vue
 * @requires Vuex
 */

// Dependencies





// Install
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

// Export
var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4_vuexfire__["firebaseMutations"]),
  modules: __WEBPACK_IMPORTED_MODULE_3__modules__["default"]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ })

},[395]);


// WEBPACK FOOTER //
// static/js/app.eebb16b97e234c0217c7.js